/* eslint-disable no-useless-escape */
/* eslint-disable react/display-name */
/* eslint-disable react/no-unknown-property */
import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
  createRef,
} from "react";

import PropTypes from "prop-types";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import Container from "react-bootstrap/Container";
import Spinner from "react-bootstrap/Spinner";
import iconsDelete from "../assets/svg/icons-delete.svg";
import iconClearSingleFilter from "../assets/svg/icons-clearSingleFilter.svg";
import AlertMessage from "../utils/AlertMessage";

import { isMobile, isMacOs } from "react-device-detect";
import iconsSearchWhite from "../assets/svg/icons-search-white.svg";
import { PREVIEW } from "../constants/stringConstants";
import iconsAddToList from "../assets/svg/icons-addToList.svg";
import DatePicker from "react-datepicker";
import { connect, useDispatch } from "react-redux";

import axios from "axios";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import "react-datepicker/dist/react-datepicker.css";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import iconsEdit from "../assets/svg/icons-edit.svg";

import CustomModal from "./CustomModal";

import { GENERATE_NEWS } from "../constants/urls";

import DOMPurify from "dompurify";
import {
  setAdditionalParams,
  setSubscriptionFrequency,
  setSubscriptionTypes,
} from "../actions/subscription";

import {
  aIQuestionDocument,
  aIQuestion,
  aiQuestionErrorMessageRaised,
} from "../actions/askQuestion";
import { bindActionCreators } from "redux";
import {
  getTilesForSavingResult,
  tilesAreLoaded,
  tilesRestartMessages,
  // tilesSuccessMessageRaised,
} from "../actions/tileActions";
import FormForSaveResults from "./FormForSaveResults";

const modules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
  ],
};

const FieldsInForm = forwardRef(
  (
    {
      fields,
      onSubmit,
      onChange,
      classNameForm,
      findFormErrors,
      idOfForm,
      submitOccurred,
      setSubmitOccurred,
      onCheckBoxChanged,
      onSelectBoxChanged,
      onMultiSelectBoxChanged,
      existingData,
      onMultiSelectOptionRemoved,
      onRadioButtonChange,
      typeOfSubmit,
      changeFieldsInFormRadioButtons,
      setChangeFieldsInFormRadioButtons,
      getTilesForSavingResult,
      tileErrorMessage,
      tileSuccessMessage,
    },
    ref
  ) => {
    const dispatch = useDispatch();
    const [form, setForm] = useState(
      Object.keys(existingData).length ? existingData : {}
    );

    const formRef = createRef(null);
    const [errors, setErrors] = useState({});
    const [changeOccurred, setChangeOccurred] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [valueQuill, setValueQuill] = useState("");
    const { t } = useTranslation();
    const [generateDialogIsShown, setGenerateDialogIsShown] = useState(false);
    const [generateTextValue, setGenerateTextValue] = useState("");
    const [url, setUrl] = useState("");
    let copyData = Object.assign({}, existingData);

    const [existingInfo, setExistingInfo] = useState(copyData);
    const [loading, isLoading] = useState(false);
    const [key, setKey] = useState(Date.now());
    const [question, setQuestion] = useState("");
    const [response, setResponse] = useState("");
    const [uploadDialogIsShown, setUploadDialogIsShown] = useState(false);

    const setField = (field, value) => {
      setForm({
        ...form,
        [field]: value,
      });

      if (field === "NEWS_URL") {
        sessionStorage.setItem("news_url", value);
      } else if (field === "SUBSCRIPTION_FREQUENCY") {
        dispatch(setSubscriptionFrequency(value));
      } else if (field === "SUBSCRIPTION_TYPES") {
        dispatch(setSubscriptionTypes(value));
      } else if (field === "SUBSCRIPTION_SEARCH_FILTER") {
        dispatch(setAdditionalParams(value));
      }
      setQuestion(value);
      setResponse("");

      if (errors[field])
        setErrors({
          ...errors,
          [field]: null,
        });
    };

    useImperativeHandle(
      ref,
      () => ({
        setField(field, value) {
          setForm({
            ...form,
            [field]: value,
          });
          sessionStorage.setItem(
            "editForm",
            JSON.stringify({
              ...form,
              [field]: value,
            })
          );

          if (errors[field])
            setErrors({
              ...errors,
              [field]: null,
            });
        },

        updateRadioButtons(value) {
          formRef.current[value].checked = true;
        },
      }),
      [form, errors, formRef]
    );

    const handleSubmit = useCallback(
      (e) => {
        if (e && typeOfSubmit !== "onChange") e.preventDefault();

        const newErrors = findFormErrors(form);

        if (typeOfSubmit === "onChange" && idOfForm === undefined) {
          onSubmit(form);
        }

        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
        } else {
          onSubmit(form);
          if (typeOfSubmit === "onChange") setErrors([]);
        }
      },
      [findFormErrors, form, idOfForm, onSubmit, typeOfSubmit]
    );
    const [currentSelected, setCurrentSelected] = useState([]);

    let check = fields.find((field) => field.name === "NEWS_TOPICS");

    useEffect(() => {
      if (check) {
        setCurrentSelected(check.selectedOptions);
      }
    }, [check]);

    // const handleChange = useCallback(() => {
    //   const updatedForm = { ...form };
    //   console.log("updatedForm", updatedForm);

    //   // if (typeOfSubmit === "onChange" && idOfForm === undefined) {
    //   //   onSubmit(form);
    //   // }
    //   fields.forEach((field) => {
    //     if (field.type !== "submit" && idOfForm !== undefined) {
    //       const fieldValue = formRef.current[field.name]?.value;
    //       console.log("fieldValue", fieldValue);

    //       if (field.name !== "NEWS_TOPICS" && idOfForm !== undefined) {
    //         updatedForm[field.name] = fieldValue;
    //         setForm(updatedForm);
    //       } else {
    //         setField(field.name, fieldValue);
    //       }
    //       if (
    //         (field.name === "NEWS_DESCRIPTION" ||
    //           field.name === "NEWS_CONTENT") &&
    //         (updatedForm.NEWS_DESCRIPTION === undefined ||
    //           updatedForm.NEWS_CONTENT === undefined ||
    //           !updatedForm.NEWS_CONTENT) &&
    //         idOfForm !== undefined
    //       ) {
    //         let getDataFromStorage = sessionStorage.getItem("question");
    //         updatedForm["NEWS_DESCRIPTION"] = getDataFromStorage;
    //         updatedForm["NEWS_CONTENT"] = getDataFromStorage;
    //       }
    //     }
    //   });

    //   const newErrors = findFormErrors(updatedForm);

    //   setErrors(newErrors);

    //   onChange(updatedForm);
    // }, [form, fields, findFormErrors, onChange, idOfForm, formRef, setField]);

    const [updatedForm, setUpdatedForm] = useState({});

    useEffect(() => {
      if (form) {
        setUpdatedForm(form);
      }
    }, [form]);

    const handleChange = useCallback(() => {
      // const updatedForm = { ...form };
      // console.log("updatedForm", updatedForm);

      if (typeOfSubmit === "onChange" && idOfForm === undefined) {
        onSubmit(form);
      }
      fields.forEach((field) => {
        if (field.type !== "submit" && idOfForm !== undefined) {
          const fieldValue = formRef.current[field.name]?.value;
          console.log("fieldValue", fieldValue);

          if (field.name !== "NEWS_TOPICS" && idOfForm !== undefined) {
            updatedForm[field.name] = fieldValue;
            setForm(updatedForm);
          } else {
            setField(field.name, fieldValue);
          }
          if (
            (field.name === "NEWS_DESCRIPTION" ||
              field.name === "NEWS_CONTENT") &&
            (updatedForm.NEWS_DESCRIPTION === undefined ||
              updatedForm.NEWS_CONTENT === undefined ||
              !updatedForm.NEWS_CONTENT) &&
            idOfForm !== undefined
          ) {
            let getDataFromStorage = sessionStorage.getItem("question");
            updatedForm["NEWS_DESCRIPTION"] = getDataFromStorage;
            updatedForm["NEWS_CONTENT"] = getDataFromStorage;
          }
        }
      });

      const newErrors = findFormErrors(updatedForm);

      setErrors(newErrors);

      onChange(updatedForm);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, fields, findFormErrors, onChange, idOfForm, formRef, setField]);

    useEffect(() => {
      if (submitOccurred || changeOccurred) {
        handleSubmit();
        setSubmitOccurred(false);
        setChangeOccurred(false);
        handleChange();
      }

      if (changeFieldsInFormRadioButtons) {
        formRef.current[changeFieldsInFormRadioButtons].checked = true;
        setChangeFieldsInFormRadioButtons(0);
      }
    }, [
      submitOccurred,
      setSubmitOccurred,
      handleSubmit,
      changeOccurred,
      changeFieldsInFormRadioButtons,
      setChangeFieldsInFormRadioButtons,
      formRef,
      handleChange,
      currentSelected,
    ]);

    function replaceCheckBoxImage(me, srcValue) {
      me.target.src = srcValue;
    }

    let axiosConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    let localStoragePersist = JSON.parse(
      window?.localStorage?.getItem("persist:configPersist")
    );
    let userToken = JSON.parse(localStoragePersist?.userToken);

    let bodyFormData = new FormData();
    bodyFormData.append("usertoken", userToken);
    bodyFormData.append("url", url);
    bodyFormData.append("question", generateTextValue);

    const asString = new URLSearchParams(bodyFormData).toString();

    const postGeneratedData = () => {
      isLoading(true);
      axios
        .post(GENERATE_NEWS, asString, axiosConfig)
        .then((response) => {
          setExistingInfo({
            ...copyData,
            NEWS_DESCRIPTION: JSON.stringify(response.data.RegHub_response),
          });
          setKey(Date.now());
          isLoading(false);
        })
        .catch((err) => {
          console.log("err :>> ", err);
          isLoading(false);
        });
    };

    const getTopicSearchFromStore = sessionStorage.getItem("TOPIC_SEARCHTAGS");
    const getTopicSingleID = localStorage.getItem("singleTopicId");
    const from = sessionStorage.getItem("fromDate");
    const to = sessionStorage.getItem("toDate");
    const pubType = sessionStorage.getItem("publicationTypes");
    const country = sessionStorage.getItem("countries");
    const freeText = sessionStorage.getItem("freeText");
    const publisherType = sessionStorage.getItem("publisherTypes");

    const isDocumentPath = location.pathname.startsWith("/document");
    const getRef = sessionStorage.getItem("reference_id");
    const separateNews = sessionStorage.getItem("separateNewsAsk");
    // eslint-disable-next-line react-redux/useSelector-prefer-selectors
    const dataFromStore = useSelector((state) => {
      return state.askQuestionReducer;
    });
    const [failureMessage, setFailureMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    useEffect(() => {
      if (dataFromStore.response) {
        setResponse(dataFromStore.response);
      }
      if (dataFromStore.aiQuestionErrorMessageRaised !== "") {
        setFailureMessage(dataFromStore.aiQuestionErrorMessageRaised);
      }
      if (dataFromStore.aIResponseAreLoading === true) {
        isLoading(true);
      } else {
        isLoading(false);
      }
    }, [dataFromStore]);

    const checkSuccess = JSON.parse(sessionStorage.getItem("success"));

    const handlePostRequest = async () => {
      setResponse("");
      isLoading(true);
      try {
        if (isDocumentPath || separateNews) {
          await dispatch(
            aIQuestionDocument(
              userToken,
              getRef,
              getTopicSingleID,
              1000,
              question
            )
          );
          sessionStorage.setItem("AIQuestion", question);
        } else {
          const freeTextParam = freeText ? freeText : "";
          const pubTypeParam = pubType ? pubType : "";
          const publisherTypeParam = publisherType ? publisherType : "";
          const countryParam = country ? country : "";
          sessionStorage.setItem("AIQuestion", question);

          await dispatch(
            aIQuestion(
              userToken,
              freeTextParam,
              getTopicSearchFromStore,
              pubTypeParam,
              from,
              to,
              publisherTypeParam,
              countryParam,
              getTopicSingleID,
              question,
              0,
              1000,
              "t"
            )
          );
        }
      } catch (error) {
        console.error("API request failed:", error);
      } finally {
        isLoading(false);
      }
    };

    const [saveResultsModal, setSaveResultsModal] = useState(false);

    useEffect(() => {
      if (checkSuccess === true && saveResultsModal === false) {
        setTimeout(() => {
          sessionStorage.removeItem("success");
          // window.location.reload();
        }, 1500);
      }
    }, [checkSuccess, saveResultsModal]);

    const handleSaveResults = () => {
      setSaveResultsModal(true);
      getTilesForSavingResult(
        userToken,
        getTopicSearchFromStore,
        getTopicSingleID
      );
    };
    const isDisable = !question?.length || !question === "";

    const sanitizedResponse = DOMPurify.sanitize(response, {
      ADD_TAGS: ["img", "a"],
      ADD_ATTR: ["target"],
      FORBID_TAGS: ["script"],
      // eslint-disable-next-line no-useless-escape
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    });

    const isDisabled = !sanitizedResponse?.length || !sanitizedResponse === "";
    const getTopicFromStore = sessionStorage.getItem("TOPIC_SEARCHTAGS");
    const [submitCreationOccurred, setSubmitCreationOccurred] = useState(false);

    // eslint-disable-next-line react-redux/useSelector-prefer-selectors
    const dataArr = useSelector((state) => {
      return state.tileReducer.tiles;
    });

    let filteredDataArr = dataArr?.filter(
      (item) => item.TILE_TYPE === "Group of tiles"
    );
    const rootArr = [
      { description: "Please select", value: "Please select" },
      {
        description: getTopicFromStore,
        value: getTopicFromStore,
      },
    ];
    if (filteredDataArr.length > 0) {
      filteredDataArr.forEach((item) => {
        rootArr.push({
          description: item.TILE_NAME,
          value: item.TILE_NAME,
        });
      });
    }

    useEffect(() => {
      if (tileErrorMessage) {
        setFailureMessage(tileErrorMessage);
      }

      if (tileSuccessMessage) {
        setSuccessMessage(tileSuccessMessage);
      }
    }, [
      tileErrorMessage,
      setFailureMessage,
      tileSuccessMessage,
      setSuccessMessage,
    ]);

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      setSelectedFile(file);
    };

    const handleUpload = () => {
      if (selectedFile) {
        const formData = new FormData();
        formData.append("pdfFile", selectedFile);

        // axios
        //   .post("/upload-pdf", formData)
        //   .then((response) => {
        //     // Handle the response from the server, if needed
        //     console.log(response.data);
        //   })
        //   .catch((error) => {
        //     // Handle errors
        //     console.error("Error uploading PDF:", error);
        //   });
      }
      alert("hello");
      setUploadDialogIsShown(false);
    };
    // const handleMultiSelectChange = (selectedOptions) => {
    //   console.log("handleSelectedOptions", selectedOptions);
    //   setForm((prevForm) => ({
    //     ...prevForm,
    //     NEWS_TOPICS: selectedOptions.map((option) => option.description),
    //   }));
    // };

    return (
      <>
        <Form
          id={idOfForm}
          onSubmit={(e) => {
            e.preventDefault();
            if (
              fields.filter((o) => o.type === "submit").length &&
              typeOfSubmit !== "onChange"
            )
              handleSubmit(e);
          }}
          onChange={(e) => {
            if (fields.filter((o) => o.type === "onChange").length)
              setChangeOccurred(true);
            idOfForm !== undefined && handleChange(e);
          }}
          className={classNameForm}
          noValidate
          ref={formRef}
        >
          {fields.map((field, index) => {
            if (field.type === "submit") {
              return (
                <Button
                  key={field.name + index}
                  type={field.type}
                  value={field.label}
                  as={field.as}
                  className={field.className}
                  variant={field.variant}
                  onClick={handleSubmit}
                />
              );
            }

            if (field.type === "checkbox") {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " checkbox"}
                  controlId={field.name}
                >
                  <Form.Check
                    name={field.name + index}
                    {...field}
                    isInvalid={!!errors[field.name]}
                    onChange={(e) => setField(field.name, e.target.checked)}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              );
            }

            if (field.type === "multi-checkbox" && field.data.length) {
              let defaultCheckedInitial = [];

              if (Object.keys(existingData).length && field.defaultChecked) {
                existingData[field.defaultChecked].split(";").forEach((tag) => {
                  if (tag) {
                    defaultCheckedInitial.push(tag);
                  }
                });
              }

              console.log("Multi-checkbox", defaultCheckedInitial);

              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " multi-checkbox"}
                  controlId={field.name}
                  isInvalid={!!errors[field.name]}
                >
                  <Form.Label
                    style={{ fontWeight: "bold" }}
                    className="form-label"
                  >
                    {field.label}
                  </Form.Label>
                  {field.data.map((checkbox, index) => {
                    console.log("Fields in form", field.firstCheckBox);
                    if (field.firstCheckBox) {
                      return (
                        <Form.Group
                          key={checkbox[field.displayProperty] + index}
                          className="multi-checkbox-single cursor-pointer"
                          controlId={checkbox[field.valueProperty]}
                        >
                          <Form.Check
                            name={field.name}
                            required={field.required}
                            className={
                              field.className + "single-checkbox cursor-pointer"
                            }
                            onChange={() => {
                              onCheckBoxChanged(checkbox[field.valueProperty]);
                            }}
                            defaultChecked={
                              defaultCheckedInitial.find(
                                (o) => o === checkbox[field.displayProperty]
                              ) &&
                              defaultCheckedInitial.find(
                                (o) => o === checkbox[field.displayProperty]
                              ).length
                                ? true
                                : false
                            }
                          />
                          <Form.Label className="check-box-label cursor-pointer">
                            <img
                              width={14}
                              height={16}
                              className={
                                checkbox[field.imageProperty]
                                  ? "check-box-img"
                                  : "display-none"
                              }
                              src={checkbox[field.imageProperty]}
                              onError={(me) =>
                                replaceCheckBoxImage(
                                  me,
                                  field.replaceImageProperty
                                )
                              }
                            />
                            <span className="check-box-label-span fs-16">
                              {checkbox[field.displayProperty]}
                            </span>
                          </Form.Label>
                        </Form.Group>
                      );
                    } else {
                      return (
                        <Form.Group
                          key={checkbox[field.displayProperty] + index}
                          className="multi-checkbox-single cursor-pointer"
                          controlId={checkbox[field.valueProperty]}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Form.Label className="check-box-label cursor-pointer ">
                            <img
                              width={14}
                              height={16}
                              className={
                                checkbox[field.imageProperty]
                                  ? "check-box-img"
                                  : "display-none"
                              }
                              src={checkbox[field.imageProperty]}
                              onError={(me) =>
                                replaceCheckBoxImage(
                                  me,
                                  field.replaceImageProperty
                                )
                              }
                            />
                            <span
                              className="check-box-label-span fs-16"
                              // style={{ marginRight: "20px" }}
                            >
                              {checkbox[field.displayProperty]}
                            </span>
                          </Form.Label>
                          <Form.Check
                            style={{}}
                            name={field.name}
                            required={field.required}
                            className={
                              field.className + "single-checkbox cursor-pointer"
                            }
                            onChange={() => {
                              onCheckBoxChanged(checkbox[field.valueProperty]);
                            }}
                            defaultChecked={
                              defaultCheckedInitial.find(
                                (o) => o === checkbox[field.displayProperty]
                              ) &&
                              defaultCheckedInitial.find(
                                (o) => o === checkbox[field.displayProperty]
                              ).length
                                ? true
                                : false
                            }
                          />
                        </Form.Group>
                      );
                    }
                  })}
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              );
            } else if (field.type === "multi-checkbox") {
              return null;
            }

            if (field.type === "multi-radiobuttons" && field.data.length) {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " multi-radiobuttons"}
                  controlId={field.name}
                >
                  <Form.Label
                    style={{ fontWeight: "bold" }}
                    className="form-label"
                  >
                    {field.label}
                  </Form.Label>
                  {field.data.map((radiobutton, indexRadio) => {
                    return (
                      <label
                        key={radiobutton[field.displayProperty] + indexRadio}
                        className={
                          field.disabled
                            ? "label-form-group-radio-button-card cursor-not-allowed"
                            : "label-form-group-radio-button-card cursor-pointer"
                        }
                        htmlFor={radiobutton[field.displayProperty] + "input"}
                      >
                        <Form.Group
                          key={radiobutton[field.displayProperty] + indexRadio}
                          className={
                            field.disabled
                              ? "multi-radiobutton-single cursor-not-allowed"
                              : "multi-radiobutton-single cursor-pointer"
                          }
                        >
                          <Form.Check
                            id={radiobutton[field.displayProperty] + "input"}
                            name={field.name}
                            type="radio"
                            className={
                              field.className +
                              " single-radiobutton cursor-pointer"
                            }
                            onChange={(e) => {
                              if (
                                typeof field.onRadioButtonChange === "function"
                              ) {
                                field.onRadioButtonChange(
                                  radiobutton[field.valueProperty]
                                );
                              } else {
                                onRadioButtonChange(
                                  radiobutton[field.valueProperty]
                                );
                              }
                              setField(field.name, e.target.value);
                            }}
                            defaultChecked={
                              field.defaultChecked ==
                              radiobutton[field.valueProperty]
                            }
                            label={radiobutton[field.displayProperty]}
                            value={
                              field.defaultChecked ==
                              radiobutton[field.valueProperty]
                            }
                            disabled={field.disabled}
                          />
                          <Form.Label
                            htmlFor={
                              radiobutton[field.displayProperty] + "input"
                            }
                            className={
                              radiobutton[field.subDisplayProperty]
                                ? "check-box-sublabel cursor-pointer"
                                : "display-none"
                            }
                          >
                            {radiobutton[field.subDisplayProperty]}
                          </Form.Label>
                        </Form.Group>
                      </label>
                    );
                  })}
                </Form.Group>
              );
            } else if (field.type === "multi-radiobuttons") {
              return null;
            }
            if (field.type === "radiobuttons-cards" && field.data.length) {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " radiobuttons-cards"}
                  controlId={field.name}
                >
                  <Form.Label
                    style={{ fontWeight: "bold" }}
                    className="form-label-of-radiobuttons-cards"
                  >
                    {field.label}
                  </Form.Label>

                  {field.data.map((radiobutton, indexRadio) => {
                    return (
                      <label
                        key={radiobutton[field.titleProperty] + indexRadio}
                        className={
                          radiobutton[field.statusProperty].toLowerCase() ===
                          PREVIEW
                            ? "label-form-group-radio-button-card cursor-not-allowed"
                            : "label-form-group-radio-button-card cursor-pointer"
                        }
                      >
                        <Form.Group
                          className={
                            radiobutton[field.statusProperty].toLowerCase() ===
                            PREVIEW
                              ? field.className +
                                // "radio-button-card preview-card"
                                " preview-card"
                              : field.className + " radio-button-card"
                          }
                          controlId={radiobutton[field.titleProperty] + "input"}
                        >
                          <div className="title-with-radio">
                            <Form.Label
                              className={
                                radiobutton[field.titleProperty]
                                  ? "radio-button-card-title"
                                  : "display-none"
                              }
                              htmlFor={
                                radiobutton[field.titleProperty] + "input"
                              }
                            >
                              {radiobutton[field.titleProperty]}
                            </Form.Label>
                            <Form.Check
                              id={radiobutton[field.titleProperty] + "input"}
                              name={field.name}
                              type="radio"
                              className={
                                radiobutton[
                                  field.statusProperty
                                ].toLowerCase() === PREVIEW
                                  ? field.classNameOfRadio +
                                    " single-radiobutton cursor-not-allowed"
                                  : field.classNameOfRadio +
                                    " single-radiobutton cursor-pointer"
                              }
                              disabled={
                                radiobutton[
                                  field.statusProperty
                                ].toLowerCase() === PREVIEW
                              }
                              onChange={(e) => {
                                if (
                                  typeof field.onRadioButtonChange ===
                                  "function"
                                ) {
                                  field.onRadioButtonChange(
                                    radiobutton[field.valueProperty]
                                  );
                                } else {
                                  onRadioButtonChange(
                                    radiobutton[field.valueProperty]
                                  );
                                }

                                setField(field.name, e.target.value);
                              }}
                              defaultChecked={
                                field.defaultChecked ==
                                radiobutton[field.valueProperty]
                              }
                              value={
                                field.defaultChecked ==
                                radiobutton[field.valueProperty]
                              }
                            />
                          </div>
                          <img
                            width={32}
                            height={32}
                            src={radiobutton[field.imageProperty]}
                            className={
                              radiobutton[field.imageProperty]
                                ? "radio-card-image"
                                : "display-none"
                            }
                          />
                          <span
                            className={
                              radiobutton[field.descriptionProperty]
                                ? "radio-button-card-explanation"
                                : "display-none"
                            }
                          >
                            {radiobutton[field.descriptionProperty]}
                          </span>
                        </Form.Group>
                      </label>
                    );
                  })}
                </Form.Group>
              );
            } else if (field.type === "radiobuttons-cards") {
              return null;
            }
            if (field.type === "select" && field.options) {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " select"}
                  controlId={field.name}
                >
                  {field.label === "Frequency (in days)" && (
                    <p
                      className="reghub-modal add-news-modal modal-header"
                      style={{
                        width: "100%",
                        maxWidth: "900px",
                        paddingBottom: "5px",
                        borderBottom: "1px solid #ddd",
                        fontSize: "28px",
                        padding: 0,
                      }}
                    >
                      Newsletter setup
                    </p>
                  )}
                  <Form.Label style={{ fontWeight: "bold" }}>
                    {field.label}
                  </Form.Label>
                  <Container className="container-for-field-and-label">
                    <Form.Control
                      as="select"
                      custom
                      disabled={field.disabled}
                      required={field.required}
                      value={field.value}
                      name={field.name}
                      isInvalid={!!errors[field.name]}
                      onChange={(e) => {
                        const selectedOption = field.options.find(
                          (option) =>
                            option[field.valueProperty] === e.target.value
                        );
                        if (selectedOption) {
                          const filterSearchValueString =
                            selectedOption.FILTER_SEARCH_VALUE;
                          if (filterSearchValueString) {
                            const filterSearchValueObject = JSON.parse(
                              filterSearchValueString
                            );
                            const freeText = filterSearchValueObject?.freeText;
                            sessionStorage.setItem("freeText", freeText);
                          } else {
                            console.error(
                              "FILTER_SEARCH_VALUE is undefined or null in selectedOption."
                            );
                          }

                          sessionStorage.setItem(
                            field.name,
                            JSON.stringify(selectedOption)
                          );
                        } else {
                          console.error(
                            "Selected option not found in field options."
                          );
                        }

                        if (typeof field.onChange === "function")
                          field.onChange(e.target.value);
                        else onSelectBoxChanged(e.target.value);

                        setField(field.name, e.target.value);
                      }}
                      defaultValue={
                        field?.name === "SAVED_FIELD" &&
                        sessionStorage.getItem("SAVED_FIELD") !== null
                          ? JSON.parse(sessionStorage.getItem("SAVED_FIELD"))
                              .FILTER_NAME
                          : field?.defaultValue && field?.name !== "SAVED_FIELD"
                          ? field.defaultValue
                          : existingData[field.name]
                      }
                    >
                      {field.placeholder ? (
                        <option
                          className="placeholder-option"
                          key={field.placeholder + "field"}
                          value={""}
                        >
                          {field.placeholder}
                        </option>
                      ) : (
                        <> </>
                      )}

                      {field.options.map((option, index) => {
                        return (
                          <option
                            key={option[field.displayProperty] + index}
                            value={option[field.valueProperty]}
                          >
                            {option[field.displayProperty]}
                          </option>
                        );
                      })}
                    </Form.Control>
                    <Form.Label
                      className={
                        field.sideLabel ? "form-side-label" : "display-none"
                      }
                    >
                      {field.sideLabel}
                    </Form.Label>
                  </Container>
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              );
            } else if (field.type === "select") {
              return null;
            }

            if (field.type === "multi-select" && field.options.length) {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " select multi-select"}
                  controlId={field.name}
                >
                  <Form.Label style={{ fontWeight: "bold" }}>
                    {field.label}
                  </Form.Label>
                  <Container className="container-for-field-and-label">
                    {/* MODAL-> TOPICS  */}
                    <Form.Control
                      as="select"
                      custom
                      isInvalid={
                        !!errors[field.name] ||
                        (idOfForm !== undefined &&
                          field.selectedOptions.length === 0)
                      }
                      disabled={field.disabled}
                      required={field.required}
                      onChange={(e) => {
                        handleChange(e);
                        if (
                          typeof field.onMultiSelectOptionChanged === "function"
                        ) {
                          field.onMultiSelectOptionChanged(
                            e.target.value,
                            field.options.filter(
                              (o) => o[field.valueProperty] === e.target.value
                            )[0][field.displayProperty]
                          );
                          const newValue = {
                            description: e.target?.value,
                            value: e.target?.value,
                          };

                          setForm((prevForm) => ({
                            ...prevForm,
                            ["NEWS_TOPICS"]: prevForm?.NEWS_TOPICS?.push(
                              newValue
                            ),
                          }));
                        } else {
                          onMultiSelectBoxChanged(
                            e.target.value,
                            field.options.filter(
                              (o) => o[field.valueProperty] === e.target.value
                            )[0][field.displayProperty]
                          );
                          const newValue = {
                            description: e.target?.value,
                            value: e.target?.value,
                          };

                          setForm((prevForm) => ({
                            ...prevForm,
                            ["NEWS_TOPICS"]: prevForm.NEWS_TOPICS.push(
                              newValue
                            ),
                          }));
                        }
                      }}
                      value=""
                    >
                      <option value="" disabled>
                        {field.placeholder}
                      </option>

                      {field.options.map((option, index) => {
                        return (
                          <option
                            key={option[field.displayProperty] + index}
                            value={option[field.valueProperty]}
                          >
                            {option[field.displayProperty]}
                          </option>
                        );
                      })}
                    </Form.Control>
                    <Form.Label
                      className={
                        field.sideLabel ? "form-side-label" : "display-none"
                      }
                    >
                      {field.sideLabel}
                    </Form.Label>
                  </Container>
                  <Container className="multi-select-selected-options-badges">
                    {idOfForm !== undefined ? (
                      <>
                        {field.selectedOptions.length &&
                        idOfForm !== undefined ? (
                          field.selectedOptions.map(
                            (selectedOption, indexBadge) => {
                              return (
                                <>
                                  <Badge
                                    key={
                                      selectedOption[field.displayProperty]
                                        ? selectedOption[
                                            field.displayProperty
                                          ] +
                                          indexBadge +
                                          1
                                        : selectedOption + indexBadge
                                    }
                                    className="multi-select-selected-badge"
                                  >
                                    <span className="multi-select-selected-badge-label">
                                      {selectedOption[field.displayProperty]
                                        ? selectedOption[field.displayProperty]
                                        : selectedOption}
                                    </span>
                                    <img
                                      src={iconClearSingleFilter}
                                      className="multi-select-selected-badge-close-icon cursor-pointer"
                                      width={24}
                                      height={24}
                                      onClick={() => {
                                        if (
                                          typeof field.onMultiSelectOptionRemoved ===
                                          "function"
                                        ) {
                                          field.onMultiSelectOptionRemoved(
                                            selectedOption[
                                              field.displayProperty
                                            ]
                                              ? selectedOption[
                                                  field.valueProperty
                                                ]
                                              : selectedOption
                                          );
                                          const filteredTopics = field.selectedOptions.filter(
                                            (topic) =>
                                              topic.value !==
                                              selectedOption[
                                                field.valueProperty
                                              ]
                                          );

                                          setForm((prevForm) => ({
                                            ...prevForm,
                                            NEWS_TOPICS: filteredTopics,
                                          }));
                                        } else {
                                          onMultiSelectOptionRemoved(
                                            selectedOption[
                                              field.displayProperty
                                            ]
                                              ? selectedOption[
                                                  field.valueProperty
                                                ]
                                              : selectedOption
                                          );
                                          const filteredTopics = field.selectedOptions.filter(
                                            (topic) =>
                                              topic.value !==
                                              selectedOption[
                                                field.valueProperty
                                              ]
                                          );

                                          setForm((prevForm) => ({
                                            ...prevForm,
                                            NEWS_TOPICS: filteredTopics.length
                                              ? filteredTopics
                                              : [],
                                          }));
                                        }
                                      }}
                                    />
                                  </Badge>
                                </>
                              );
                            }
                          )
                        ) : (
                          <>
                            {idOfForm !== undefined && (
                              <Form.Control.Feedback type="invalid">
                                {errors[field.name]}
                              </Form.Control.Feedback>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {field.label === "Publication type" &&
                          sessionStorage.setItem(
                            "publicationTypes",
                            field.selectedOptions
                              .map((obj) => obj.value)
                              .join(";")
                          )}
                        {field.label === "Country" &&
                          sessionStorage.setItem(
                            "country",
                            field.selectedOptions
                              .map((obj) => obj.value)
                              .join(";")
                          )}
                        {field.label === "Publisher type" &&
                          sessionStorage.setItem(
                            "publisherTypes",
                            field.selectedOptions
                              .map((obj) => obj.value)
                              .join(";")
                          )}
                        {field.selectedOptions.length > 0 &&
                          field.selectedOptions.map(
                            (selectedOption, indexBadge) => {
                              return (
                                <>
                                  <Badge
                                    key={
                                      selectedOption[field.displayProperty]
                                        ? selectedOption[
                                            field.displayProperty
                                          ] +
                                          indexBadge +
                                          1
                                        : selectedOption + indexBadge
                                    }
                                    className="multi-select-selected-badge"
                                  >
                                    <span className="multi-select-selected-badge-label">
                                      {selectedOption[field.displayProperty]
                                        ? selectedOption[field.displayProperty]
                                        : selectedOption}
                                    </span>
                                    <img
                                      src={iconClearSingleFilter}
                                      className="multi-select-selected-badge-close-icon cursor-pointer"
                                      width={24}
                                      height={24}
                                      onClick={() => {
                                        if (
                                          typeof field.onMultiSelectOptionRemoved ===
                                          "function"
                                        ) {
                                          field.onMultiSelectOptionRemoved(
                                            selectedOption[
                                              field.displayProperty
                                            ]
                                              ? selectedOption[
                                                  field.valueProperty
                                                ]
                                              : selectedOption
                                          );
                                          // const filteredTopics = field.selectedOptions.filter(
                                          //   (topic) =>
                                          //     topic.value !==
                                          //     selectedOption[
                                          //       field.valueProperty
                                          //     ]
                                          // );

                                          // setForm((prevForm) => ({
                                          //   ...prevForm,
                                          //   NEWS_TOPICS: filteredTopics,
                                          // }));
                                        } else {
                                          onMultiSelectOptionRemoved(
                                            selectedOption[
                                              field.displayProperty
                                            ]
                                              ? selectedOption[
                                                  field.valueProperty
                                                ]
                                              : selectedOption
                                          );
                                          // const filteredTopics = field.selectedOptions.filter(
                                          //   (topic) =>
                                          //     topic.value !==
                                          //     selectedOption[
                                          //       field.valueProperty
                                          //     ]
                                          // );

                                          // setForm((prevForm) => ({
                                          //   ...prevForm,
                                          //   NEWS_TOPICS: filteredTopics.length
                                          //     ? filteredTopics
                                          //     : [],
                                          // }));
                                        }
                                      }}
                                    />
                                  </Badge>
                                </>
                              );
                            }
                          )}
                      </>
                    )}
                  </Container>
                </Form.Group>
              );
            } else if (field.type === "multi-select") {
              return null;
            }

            if (field.type === "date" && field.options.length && !isMacOs) {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " date-fields"}
                  controlId={field.name}
                >
                  <Form.Label style={{ fontWeight: "bold" }}>
                    {field.label}
                  </Form.Label>
                  {field.options.map((option) => {
                    return (
                      <Form.Control
                        onChange={(e) => {
                          let { onChangeDate } = option;
                          if (typeof option.onChangeDate === "function")
                            onChangeDate(e.target.value);

                          setField(option.name, e.target.value);
                        }}
                        key={option.key}
                        {...option}
                        isInvalid={!!errors[field.name]}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    );
                  })}
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              );
            } else if (
              field.type === "date" &&
              field.options.length &&
              isMacOs
            ) {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " date-fields"}
                  controlId={field.name}
                >
                  <Form.Label style={{ fontWeight: "bold" }}>
                    {field.label}
                  </Form.Label>
                  {field.options.map((option) => {
                    return (
                      <DatePicker
                        onChange={(date) => {
                          let { onChangeDate } = option;
                          console.log("Fields in form", date);
                          if (typeof option.onChangeDate === "function")
                            onChangeDate(date);

                          setField(option.name, date);
                        }}
                        selected={field.value}
                        key={option.key}
                        {...option}
                        isInvalid={!!errors[field.name]}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    );
                  })}
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              );
            } else if (field.type === "date") {
              return null;
            }

            if (field.type === "multiple-text-fields" && field.data.length) {
              return (
                <React.Fragment key={field.name + index}>
                  {field.data.map((option, indexOfTextField) => {
                    return (
                      <Form.Group
                        key={option[field.displayProperty] + indexOfTextField}
                        className={field.classnameofgroup + " field"}
                        controlId={field.name}
                      >
                        <Form.Label style={{ fontWeight: "bold" }}>
                          {field.label}
                        </Form.Label>
                        <div className="multiple-text-fields-div-group">
                          <Form.Control
                            type="text"
                            isInvalid={!!errors[field.name]}
                            disabled={field.disabled}
                            value={option[field.displayProperty]}
                          />
                          <img
                            src={iconsDelete}
                            width={24}
                            height={24}
                            className="field-set-close cursor-pointer"
                            onClick={() => {
                              field.onTextFieldDelete(
                                option[field.valueProperty]
                              );
                              sessionStorage.removeItem(
                                "SUBSCRIPTION_SEARCH_FILTER"
                              );
                            }}
                          />
                        </div>
                        <Form.Control.Feedback type="invalid">
                          {errors[option.name]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    );
                  })}
                </React.Fragment>
              );
            } else if (field.type === "multiple-text-fields") {
              return null;
            }

            if (field.type === "text-with-search" && !isMobile) {
              return (
                <Form.Group
                  key={field.name + index}
                  className={field.classnameofgroup + " text-with-search field"}
                  controlId={field.name}
                >
                  <Form.Label style={{ fontWeight: "bold" }}>
                    {field.label}
                  </Form.Label>
                  <div className="text-with-search-div-group">
                    <Form.Control
                      {...field}
                      type={field.type}
                      isInvalid={!!errors[field.name]}
                      onChange={(e) => {
                        setField(field.name, e.target.value);
                        if (typeof field.onChangeText === "function") {
                          field.onChangeText(e.target.value);
                        }
                      }}
                      defaultValue={
                        existingData ? existingData[field.name] : null
                      }
                      onKeyPress={(e) => {
                        if (
                          e.key === "Enter" &&
                          form[field.name] &&
                          typeof field.onSearch === "function"
                        ) {
                          field.onSearch();
                        }
                      }}
                    />
                    <div
                      className={
                        form[field.name]
                          ? "text-field-search-button"
                          : "text-field-search-button-disabled"
                      }
                      onClick={() => {
                        if (
                          form[field.name] &&
                          typeof field.onSearch === "function"
                        ) {
                          field.onSearch();
                        }
                      }}
                    >
                      <img
                        width={24}
                        height={24}
                        src={iconsSearchWhite}
                        className={"text-field-search-button-icon"}
                      />
                    </div>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              );
            }

            if (field.type === "textarea") {
              return (
                <>
                  <Form.Group
                    key={field.name + index}
                    className={field.classnameofgroup + " field"}
                    controlId={field.name}
                    isInvalid={!!errors[field.name]}
                  >
                    {field.label === "Description" && (
                      <>
                        <Form.Label
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {field.label}

                          <button
                            className="generate-button"
                            type="button"
                            onClick={() => {
                              setGenerateDialogIsShown(true);
                              let savedUrl = sessionStorage.getItem("news_url");
                              setUrl(savedUrl);
                              sessionStorage.removeItem("generated_response");
                            }}
                          >
                            <img
                              width={24}
                              height={24}
                              src={iconsEdit}
                              className="left-options-icon"
                            />
                            <p className="overview-second-col-card-btn-text fs-14">
                              {t("generate")}
                            </p>
                          </button>
                          <CustomModal
                            titleOfModal={t("generateDescription")}
                            positiveButton={t("generate")}
                            negativeButton={t("cancel")}
                            positiveAction={() => {
                              if (generateTextValue !== "") {
                                postGeneratedData();
                                setGenerateTextValue("");
                                setGenerateDialogIsShown(false);
                              }
                            }}
                            negativeAction={() => {
                              setGenerateDialogIsShown(false);
                            }}
                            setIsShown={setGenerateDialogIsShown}
                            isShown={generateDialogIsShown}
                            classNameOfModal="reghub-modal reghub-modal-add-new-tile"
                            id="add-new-topic-group-form"
                            content={
                              <div className="modal-container">
                                <p style={{ fontWeight: "bold" }}>
                                  Specify your request
                                </p>
                                <textarea
                                  className="generate-textarea"
                                  placeholder="e.g. Create a short summary for the news"
                                  onChange={(e) => {
                                    setGenerateTextValue(e.target.value);
                                  }}
                                />
                              </div>
                            }
                            isBackdrop="static"
                          />
                        </Form.Label>

                        <Container className="container-for-field-and-label">
                          {loading && (
                            <div className="custom-loader">
                              <Spinner animation="border" className="loader">
                                <span className="sr-only">{t("loading")}</span>
                              </Spinner>
                            </div>
                          )}

                          <div
                            className={`${
                              valueQuill.length > 1500 &&
                              field.name === "NEWS_DESCRIPTION"
                                ? "container-for-field-and-label-warn"
                                : ""
                            } ${
                              valueQuill.length === 0 &&
                              field.name === "NEWS_DESCRIPTION" &&
                              "container-for-field-and-label-warn"
                            }`}
                            style={{
                              overflowY: "auto",
                              maxHeight: "600px",
                            }}
                          >
                            <ReactQuill
                              errors={[field.name]}
                              key={key}
                              theme="snow"
                              modules={modules}
                              {...field}
                              type={field.type}
                              as="textarea"
                              onChange={(e) => {
                                let data = e.replace(/<[^>]*>/g, "");
                                setValueQuill(data);
                                setField(field.name, data);

                                let { onChangeText } = field;
                                if (typeof onChangeText === "function")
                                  onChangeText(data);
                              }}
                              onKeyPress={(e) => {
                                setField(field.name, e.target.value);
                                if (
                                  (e.charCode === 13 || e.key === "Enter") &&
                                  isMobile
                                ) {
                                  let { onSearch } = field;
                                  if (typeof onSearch === "function")
                                    onSearch(e.target.value);
                                }
                              }}
                              defaultValue={
                                existingInfo
                                  ? existingInfo[field.name]
                                  : undefined
                              }
                            />

                            {/* <Form.Control.Feedback type="invalid">
                              {errors[("NEWS_DESCRIPTION", valueQuill)]}
                            </Form.Control.Feedback> */}
                          </div>
                          {valueQuill.length > 1500 &&
                          field.name === "NEWS_DESCRIPTION" ? (
                            <p className="warn-message">
                              The number of characters in the description field
                              is limited to 1500. The current text exceeds this
                              limit{" "}
                            </p>
                          ) : (
                            field.name === "NEWS_DESCRIPTION" &&
                            valueQuill.length > 0 && (
                              <p className="base-message">
                                Current description length: {valueQuill.length}
                              </p>
                            )
                          )}

                          {field.label === "Description" &&
                            field.name === "NEWS_DESCRIPTION" &&
                            valueQuill.length === 0 && (
                              <p className="warn-message">
                                News description is mandatory field
                              </p>
                            )}

                          <Form.Label
                            className={
                              field.sideLabel
                                ? "form-side-label"
                                : "display-none"
                            }
                          >
                            {field.sideLabel}
                          </Form.Label>
                        </Container>
                      </>
                    )}
                    {field.label === "Content" && (
                      <>
                        <Form.Label
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {field.label}
                          <button
                            style={{ display: "none" }}
                            className="generate-button"
                            type="button"
                            onClick={() => {
                              setUploadDialogIsShown(true);
                              // let savedUrl = sessionStorage.getItem("news_url");
                              // setUrl(savedUrl);
                              // sessionStorage.removeItem("generated_response");
                            }}
                          >
                            <p className="overview-second-col-card-btn-text fs-14">
                              {t("upload")}
                            </p>
                          </button>
                          <CustomModal
                            titleOfModal={t("uploadFile")}
                            positiveButton={t("upload")}
                            negativeButton={t("cancel")}
                            positiveAction={() => {
                              handleUpload();
                              // if (generateTextValue !== "") {
                              //   postGeneratedData();
                              //   setGenerateTextValue("");
                              //   setGenerateDialogIsShown(false);
                              // }
                            }}
                            negativeAction={() => {
                              setUploadDialogIsShown(false);
                            }}
                            setIsShown={setUploadDialogIsShown}
                            isShown={uploadDialogIsShown}
                            classNameOfModal="reghub-modal reghub-modal-add-new-tile"
                            id="add-new-topic-group-form"
                            content={
                              <div className="modal-container">
                                <label htmlFor="fileInput">Upload PDF:</label>
                                <input
                                  type="file"
                                  id="fileInput"
                                  accept=".pdf"
                                  onChange={handleFileChange}
                                />
                              </div>
                            }
                            isBackdrop="static"
                          />
                        </Form.Label>
                        <Container
                          className="container-for-field-and-label"
                          style={{
                            overflowY: "auto",
                            maxHeight: "600px",
                          }}
                        >
                          <ReactQuill
                            theme="snow"
                            modules={modules}
                            {...field}
                            type={field.type}
                            as="textarea"
                            onChange={(e) => {
                              let data = e.replace(/<[^>]*>/g, "");
                              setField(field.name, data);

                              let { onChangeText } = field;
                              if (typeof onChangeText === "function")
                                onChangeText(data);
                            }}
                            onKeyPress={(e) => {
                              setField(field.name, e.target.value);
                              if (
                                (e.charCode === 13 || e.key === "Enter") &&
                                isMobile
                              ) {
                                let { onSearch } = field;
                                if (typeof onSearch === "function")
                                  onSearch(e.target.value);
                              }
                            }}
                            defaultValue={
                              existingInfo ? existingInfo[field.name] : ""
                            }
                          />
                          <Form.Label
                            className={
                              field.sideLabel
                                ? "form-side-label"
                                : "display-none"
                            }
                          >
                            {field.sideLabel}
                          </Form.Label>
                        </Container>
                      </>
                    )}
                    {field.label === "Your Question" && (
                      <>
                        <Form.Label
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {field.label}
                        </Form.Label>

                        <Container className="container-for-field-and-label">
                          <textarea
                            className="ask-question-textarea-field"
                            {...field}
                            type={field.type}
                            isInvalid={!!errors[field.name]}
                            onChange={(e) => {
                              setField(field.name, e.target.value);
                              let { onChangeText } = field;
                              if (typeof onChangeText === "function")
                                onChangeText(e.target.value);
                            }}
                            onKeyPress={(e) => {
                              setField(field.name, e.target.value);
                              if (
                                (e.charCode === 13 || e.key === "Enter") &&
                                isMobile
                              ) {
                                let { onSearch } = field;
                                if (typeof onSearch === "function")
                                  onSearch(e.target.value);
                              }
                            }}
                          />
                          <Form.Label
                            className={
                              field.sideLabel
                                ? "form-side-label"
                                : "display-none"
                            }
                          >
                            {field.sideLabel}
                          </Form.Label>
                        </Container>
                        <div className="startAnalysisContainer">
                          <button
                            className={`${
                              isDisable === true
                                ? "cursor-not-allowed modal-positive-button apply-bg-approx-analog-color fs-14 btn-primary btn"
                                : "modal-positive-button apply-bg-approx-analog-color fs-14 btn btn-primary"
                            }`}
                            onClick={handlePostRequest}
                            disabled={isDisable}
                          >
                            Start Analysis
                          </button>
                        </div>
                      </>
                    )}
                    {field.label === "The Answer" && (
                      <>
                        {loading && (
                          <div className="custom-loader">
                            <Spinner animation="border" className="loader">
                              <span className="sr-only">{t("loading")}</span>
                            </Spinner>
                          </div>
                        )}
                        <Form.Label
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {field.label}
                        </Form.Label>
                        <p
                          className="answer-textarea-field"
                          dangerouslySetInnerHTML={{
                            __html: sanitizedResponse,
                          }}
                        />
                        <div
                          className={`${
                            isDisabled
                              ? "saveResultsContainerHided"
                              : "saveResultsContainer"
                          }`}
                        >
                          <button
                            className="modal-positive-button apply-bg-approx-analog-color fs-14 btn btn-primary"
                            onClick={handleSaveResults}
                          >
                            Save Results
                          </button>
                        </div>
                      </>
                    )}
                    {field.label !== "Description" &&
                      field.label !== "Content" &&
                      field.label !== "Your Question" &&
                      field.label !== "Search criteria" &&
                      field.label !== "The Answer" && (
                        <>
                          <Form.Label
                            style={{
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {field.label}
                          </Form.Label>

                          <Container className="container-for-field-and-label">
                            {loading && (
                              <div className="custom-loader">
                                <Spinner animation="border" className="loader">
                                  <span className="sr-only">
                                    {t("loading")}
                                  </span>
                                </Spinner>
                              </div>
                            )}
                            <textarea
                              className="textarea-for-search-criteria"
                              {...field}
                              type={field.type}
                              isInvalid={!!errors[field.name]}
                              onChange={(e) => {
                                setField(field.name, e.target.value);
                                let { onChangeText } = field;
                                if (typeof onChangeText === "function")
                                  onChangeText(e.target.value);
                              }}
                              onKeyPress={(e) => {
                                setField(field.name, e.target.value);
                                if (
                                  (e.charCode === 13 || e.key === "Enter") &&
                                  isMobile
                                ) {
                                  let { onSearch } = field;
                                  if (typeof onSearch === "function")
                                    onSearch(e.target.value);
                                }
                              }}
                              defaultValue={
                                existingData
                                  ? existingData.TOPIC_SEARCHTAGS
                                  : undefined
                              }
                            />

                            <Form.Label
                              className={
                                field.sideLabel
                                  ? "form-side-label"
                                  : "display-none"
                              }
                            >
                              {field.sideLabel}
                            </Form.Label>
                          </Container>
                        </>
                      )}
                    {field.label !== "Description" &&
                      field.label !== "Content" &&
                      field.label !== "Your Question" &&
                      field.label !== "The Answer" &&
                      field.label !== "AI Prompt" && (
                        <>
                          <Form.Label
                            style={{
                              fontWeight: "bold",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {field.label}
                          </Form.Label>

                          <Container className="container-for-field-and-label">
                            {loading && (
                              <div className="custom-loader">
                                <Spinner animation="border" className="loader">
                                  <span className="sr-only">
                                    {t("loading")}
                                  </span>
                                </Spinner>
                              </div>
                            )}
                            <textarea
                              className="textarea-for-search-criteria"
                              {...field}
                              type={field.type}
                              isInvalid={!!errors[field.name]}
                              onChange={(e) => {
                                setField(field.name, e.target.value);
                                let { onChangeText } = field;
                                if (typeof onChangeText === "function")
                                  onChangeText(e.target.value);
                              }}
                              onKeyPress={(e) => {
                                setField(field.name, e.target.value);
                                if (
                                  (e.charCode === 13 || e.key === "Enter") &&
                                  isMobile
                                ) {
                                  let { onSearch } = field;
                                  if (typeof onSearch === "function")
                                    onSearch(e.target.value);
                                }
                              }}
                              defaultValue={
                                existingData
                                  ? existingData.TOPIC_SEARCHTAGS
                                  : undefined
                              }
                            />
                            <Form.Label
                              className={
                                field.sideLabel
                                  ? "form-side-label"
                                  : "display-none"
                              }
                            >
                              {field.sideLabel}
                            </Form.Label>
                          </Container>
                        </>
                      )}
                    {field.label === "Save Results" && (
                      <>
                        <Form.Label
                          style={{
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {field.label}
                        </Form.Label>

                        <Container className="container-for-field-and-label">
                          <textarea
                            className="ask-question-textarea-field"
                            {...field}
                            type={field.type}
                            isInvalid={!!errors[field.name]}
                            onChange={(e) => {
                              setField(field.name, e.target.value);
                              let { onChangeText } = field;
                              if (typeof onChangeText === "function")
                                onChangeText(e.target.value);
                            }}
                            onKeyPress={(e) => {
                              setField(field.name, e.target.value);
                              if (
                                (e.charCode === 13 || e.key === "Enter") &&
                                isMobile
                              ) {
                                let { onSearch } = field;
                                if (typeof onSearch === "function")
                                  onSearch(e.target.value);
                              }
                            }}
                          />
                          <Form.Label
                            className={
                              field.sideLabel
                                ? "form-side-label"
                                : "display-none"
                            }
                          >
                            {field.sideLabel}
                          </Form.Label>
                        </Container>
                        <div className="startAnalysisContainer">
                          <button
                            className={`${
                              isDisable === true
                                ? "cursor-not-allowed modal-positive-button apply-bg-approx-analog-color fs-14 btn-primary btn"
                                : "modal-positive-button apply-bg-approx-analog-color fs-14 btn btn-primary"
                            }`}
                            onClick={handlePostRequest}
                            disabled={isDisable}
                          >
                            Start Analysis
                          </button>
                        </div>
                      </>
                    )}
                    <Form.Control.Feedback type="invalid">
                      {errors[field.name]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </>
              );
            }

            if (field.type === "multiple-text-fields-in-a-row") {
              let { data } = field;
              return (
                <Form.Group
                  key={field.name + index}
                  className={
                    field.classnameofgroup + " field multiple-text-fields"
                  }
                  controlId={field.name}
                >
                  {data.map((fieldRow, index) => {
                    return (
                      <Form.Group
                        key={"field-row" + index + Math.random()}
                        className="field-row"
                      >
                        <Form.Group className="first-field-in-row">
                          <Form.Label style={{ fontWeight: "bold" }}>
                            {field.first_field_label}
                          </Form.Label>
                          <Form.Control
                            className="first-field-in-row"
                            type={"text"}
                            onBlur={(e) => {
                              let { changeOfValue } = field;
                              if (typeof changeOfValue === "function")
                                changeOfValue(
                                  field.first_display_property,
                                  e.target.value,
                                  index
                                );
                            }}
                            placeholder={field.first_field_placeholder}
                            defaultValue={
                              fieldRow[field.first_display_property]
                            }
                          />
                        </Form.Group>
                        <Form.Group className="second-field-in-row">
                          <Form.Label>{field.second_field_label}</Form.Label>
                          <Form.Control
                            className="second-field-in-row"
                            type={"text"}
                            onBlur={(e) => {
                              let { changeOfValue } = field;
                              if (typeof changeOfValue === "function")
                                changeOfValue(
                                  field.second_display_property,
                                  e.target.value,
                                  index
                                );
                            }}
                            placeholder={field.second_field_placeholder}
                            defaultValue={
                              fieldRow[field.second_display_property]
                            }
                          />
                        </Form.Group>
                        <img
                          width={24}
                          height={24}
                          className={
                            field.labelOfBottomButton
                              ? "field-remove-button cursor-pointer"
                              : "display-none"
                          }
                          alt="field-remove-button"
                          src={iconsDelete}
                          onClick={() => field.removeARow(index)}
                        />
                      </Form.Group>
                    );
                  })}
                  <div
                    className={
                      field.labelOfBottomButton
                        ? "add-new-field-button cursor-pointer"
                        : "display-none"
                    }
                    onClick={() => field.addARow()}
                  >
                    <img
                      width={24}
                      height={24}
                      className="add-new-field-button-img"
                      alt="add-new-field-button-img"
                      src={iconsAddToList}
                    />
                    <span className="add-new-field-button-label">
                      {field.labelOfBottomButton}
                    </span>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              );
            }

            return (
              <Form.Group
                key={field.name + index}
                className={field.classnameofgroup + " field"}
                controlId={field.name}
              >
                <Form.Label style={{ fontWeight: "bold" }}>
                  {field.label}
                </Form.Label>
                <Container className="container-for-field-and-label">
                  <Form.Control
                    {...field}
                    type={field.type}
                    isInvalid={!!errors[field.name]}
                    onChange={(e) => {
                      setField(field.name, e.target.value);
                      let { onChangeText } = field;
                      if (typeof onChangeText === "function")
                        onChangeText(e.target.value);
                    }}
                    onKeyPress={(e) => {
                      setField(field.name, e.target.value);
                      if (
                        (e.charCode === 13 || e.key === "Enter") &&
                        isMobile
                      ) {
                        let { onSearch } = field;
                        if (typeof onSearch === "function")
                          onSearch(e.target.value);
                      }
                    }}
                    defaultValue={
                      existingData ? existingData[field.name] : undefined
                    }
                  />
                  <Form.Label
                    className={
                      field.sideLabel ? "form-side-label" : "display-none"
                    }
                  >
                    {field.sideLabel}
                  </Form.Label>
                </Container>
                <Form.Control.Feedback type="invalid">
                  {errors[field.name]}
                </Form.Control.Feedback>
              </Form.Group>
            );
          })}
        </Form>
        <CustomModal
          titleOfModal={t("saveResults")}
          isShown={saveResultsModal}
          setIsShown={setSaveResultsModal}
          isBackdrop="static"
          isCentered={true}
          classNameOfModal="reghub-modal add-news-modal ask"
          content={
            <FormForSaveResults
              submitOccurred={submitCreationOccurred}
              setSubmitCreationOccurred={setSubmitCreationOccurred}
              negativeButton={t("close")}
              negativeAction={() => {
                setSaveResultsModal(false);
              }}
              positiveButton={t("save")}
              positiveAction={() => {
                setSaveResultsModal(false);
                setSubmitCreationOccurred(true);
              }}
            />
          }
        />
        {failureMessage ? (
          <AlertMessage
            variant="danger"
            onClose={() => {
              setFailureMessage("");
              aiQuestionErrorMessageRaised("");
              tilesRestartMessages();
            }}
            successHeading={t("failure")}
            mainMessage={failureMessage}
          />
        ) : (
          ""
        )}
        {successMessage ? (
          <AlertMessage
            variant="success"
            onClose={() => {
              setSuccessMessage("");
              tilesRestartMessages();
            }}
            successHeading={t("success")}
            mainMessage={successMessage}
          />
        ) : (
          <div className="display-none" />
        )}
      </>
    );
  }
);

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    tileSuccessMessage: state.tileReducer.tileSuccessMessage,
    tileErrorMessage: state.tileReducer.tileErrorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTilesForSavingResult: bindActionCreators(
      getTilesForSavingResult,
      dispatch
    ),
    tilesAreLoaded: bindActionCreators(tilesAreLoaded, dispatch),
    tilesRestartMessages: bindActionCreators(tilesRestartMessages, dispatch),
  };
};

FieldsInForm.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      className: PropTypes.string,
      required: PropTypes.bool,
      classnameofgroup: PropTypes.string,
      label: PropTypes.string,
      onChangeText: PropTypes.func,
      onChangeDate: PropTypes.func,
    })
  ).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  classNameForm: PropTypes.string.isRequired,
  findFormErrors: PropTypes.func.isRequired,
  idOfForm: PropTypes.string,
  setSubmitOccurred: PropTypes.func.isRequired,
  submitOccurred: PropTypes.bool.isRequired,
  onCheckBoxChanged: PropTypes.func.isRequired,
  onSelectBoxChanged: PropTypes.func.isRequired,
  onMultiSelectBoxChanged: PropTypes.func.isRequired,
  existingData: PropTypes.shape({
    NEWS_DESCRIPTION: PropTypes.string.isRequired,
    TOPIC_SEARCHTAGS: PropTypes.string,
  }).isRequired,
  onMultiSelectOptionRemoved: PropTypes.func.isRequired,
  onRadioButtonChange: PropTypes.func.isRequired,
  typeOfSubmit: PropTypes.string.isRequired,
  changeFieldsInFormRadioButtons: PropTypes.number.isRequired,
  setChangeFieldsInFormRadioButtons: PropTypes.func.isRequired,
  generateNewsItemAction: PropTypes.func.isRequired,
  setFreeText: PropTypes.func.isRequired,
  additionalParams: PropTypes.string,
  setAskAQuestionModal: PropTypes.func,
  getTilesForSavingResult: PropTypes.func.isRequired,
  tilesAreLoaded: PropTypes.func.isRequired,
  tileSuccessMessage: PropTypes.string.isRequired,
  tileErrorMessage: PropTypes.string.isRequired,
  tilesRestartMessages: PropTypes.func.isRequired,
};

FieldsInForm.defaultProps = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: "",
      type: "",
      className: "",
      required: false,
      classnameofgroup: "",
      label: "",
      defaultChecked: "",
      onChangeText: () => {},
      onChangeDate: () => {},
    })
  ),
  onSubmit: () => {},
  onChange: () => {},
  classNameForm: "",
  findFormErrors: () => {},
  idOfForm: undefined,
  setSubmitOccurred: () => {},
  submitOccurred: false,
  onCheckBoxChanged: () => {},
  onSelectBoxChanged: () => {},
  onMultiSelectBoxChanged: () => {},

  // existingData: {},
  existingData: {
    NEWS_DESCRIPTION: "",
  },
  onMultiSelectOptionRemoved: () => {},
  onRadioButtonChange: () => {},
  typeOfSubmit: "",
  changeFieldsInFormRadioButtons: 0,
  setChangeFieldsInFormRadioButtons: () => {},
  generateNewsItemAction: () => {},
  aIQuestionDocument: () => {},
  aIQuestion: () => {},
  getTilesForSavingResult: () => {},
  tilesAreLoaded: () => {},
  tileSuccessMessage: "",
  tileErrorMessage: "",
  tilesRestartMessages: () => {},
  setAskAQuestionModal: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(FieldsInForm);
